import type { AutomationFailureResponse } from '@urbanx/agx.support.client';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { getAutomationAreaLabel, getAutomationReasonLabel } from './automationFailurePresentation';

interface AutomationFailureDetailHeaderProps {
  failure?: AutomationFailureResponse;
}

const AutomationFailureDetailHeader = ({ failure }: AutomationFailureDetailHeaderProps) => (
  <AgxSpacer
    direction="vertical"
    contentAlignment="center"
    gap="xxs"
    style={{ margin: '0 auto', textAlign: 'center' }}
  >
    <AgxTypography
      id="automation-failure-title"
      type="body_ui_strong"
      size="medium"
      color="var(--text-primary)"
    >
      {failure?.automationName ? `${failure.automationName} failed` : 'Automation failure'}
    </AgxTypography>
    {failure && (
      <AgxTypography
        id="automation-failure-meta"
        type="body_ui"
        size="small"
        color="var(--text-tertiary)"
      >
        {getAutomationAreaLabel(failure.area)} · {getAutomationReasonLabel(failure.reason)} ·{' '}
        {failure.reference}
      </AgxTypography>
    )}
  </AgxSpacer>
);

export default AutomationFailureDetailHeader;
